import Router from 'vue-router';
import _ from 'lodash';

import Login from './views/login/router';
import Model from './views/model/router';

let routes = [
    {
        path: '/',
        name: 'index'
    }
];

_.forEach([Login, Model], item => {
    if (_.isArray(item)) {
        routes = routes.concat(item);
    } else {
        routes.push(item);
    }
});

export default new Router({
    routes
});